import React from 'react';

export default function (props) {
	return <div className="card">{ props.children }</div>
}
